<template>
  <div class="home">


    <img src="../assets/1.png" height="60px" width="100%"/>
    <div style="width: 100%;height: 35px;background-color: #3a5a73;display: flex;flex-direction: row;align-items: center">
      <div
        v-for="(item, index) in navItems"
        :key="index"
        :style="{
          marginLeft: index === 0 ? '187px' : '12px',
          backgroundColor: activeIndex === index ? '#ff9900' : '#cccccc',
          height: '25px',
          paddingLeft: '20px',
          paddingRight: '20px',
          display: 'flex',
          alignItems: 'center',
          fontSize: '12px',
          lineHeight: '30px',
          borderRadius: '3px',
          cursor: index < 5 ? 'pointer' : 'default'
        }"
        @click="index < 5 && (activeIndex = index)"
      >{{ item }}</div>





    </div>

    <img v-if="activeIndex === 0" src="../assets/10.png" width="100%"/>
    <img v-if="activeIndex === 1" src="../assets/11.png" width="100%"/>
    <img v-if="activeIndex === 2" src="../assets/12.png" width="100%"/>
    <img v-if="activeIndex === 3" src="../assets/13.png" width="100%"/>
    <img v-if="activeIndex === 4" src="../assets/14.png" width="100%"/>



  </div>

</template>

<script setup>
import { ref } from 'vue'

const activeIndex = ref(0)
const navItems = ['首页', '考试报名', '考试成绩', '在线评测', '信息修改', '个人信息']
</script>

<style>
.home {
  /*background-color: #2c3e50;*/

  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>

